//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { flattenProductMatchVariants } from '@instagram-account/post-details/postDetailsUIUtils';
import { ICuralateStore } from '@models/AppState';

export const getCurrentSelectedProducts = createSelector(
  (state: ICuralateStore) =>
    state.instagram.shops.productSearchModal.selectedProducts,
  (selectedProducts) => selectedProducts ?? [],
);

export const getCurrentSearchResults = createSelector(
  (state: ICuralateStore) =>
    state.instagram.shops.productSearchModal.searchResults,
  (searchResults) => searchResults,
);

export const getCurrentProductMatches = createSelector(
  (state: ICuralateStore) =>
    state.instagram.shops.productSearchModal.productMatches,
  (productMatches) => productMatches,
);

export const getSelectedProductMatch = createSelector(
  (state: ICuralateStore, selectedProductId: string) => selectedProductId,
  getCurrentSearchResults,
  getCurrentProductMatches,
  (selectedProductId: string, searchResult, productMatches) => {
    return flattenProductMatchVariants([
      ...productMatches,
      ...searchResult,
    ]).find((product) => product.productId === selectedProductId);
  },
);

export const getUpdatedProductSelections = createSelector(
  (state: ICuralateStore, selectedProductId: string) =>
    getSelectedProductMatch(state, selectedProductId),
  getCurrentSelectedProducts,
  (selectedProduct, currentProducts) => {
    return [...currentProducts, ...(selectedProduct ? [selectedProduct] : [])];
  },
);
